export const COUNTRIES = [
    {
        name: "Côte d'Ivoire",
        code: "CI",
        phoneCode: "+225",
        continent: "Afrique",
        cities: [
            "Abidjan",
            "Bouaké",
            "yamoussoukro",
        ]
    },
    {
        name: "Gabon",
        code: "GA",
        phoneCode: "+241",
        continent: "Afrique",
        cities: [
            "Libreville",
            "Port-Gentil",
            "Franceville",
        ]
    },
    {
        name: "France",
        code: "FR",
        phoneCode: "+33",
        continent: "Europe",
        cities: [
            "Paris",
            "Marseille",
            "Nice",
        ]
    }
];
